import { CpsGlobalFilter } from '../search/CpsGlobalFilter';

export const EDITING_VIEW_FIELD = {
  ID: 'id' as const,
  NAME: 'name' as const,
  WIDTH: 'width' as const,
  FACETABLE: 'facetable' as const,
  FACETS_COUNT: 'facetsCount' as const,
  LINK: 'isDocumentLink' as const,
  REMOVE: 'remove' as const,
  IS_NEW: 'isNew' as const
} as const;

export interface EditingViewField {
  id: number;
  name: string;
  width: number;
  facetable?: boolean;
  facetsCount?: number;
  isDocumentLink: boolean;
  isNew?: boolean;
  remove?: string;
}

export interface EditingViewState {
  fields: EditingViewField[];
  activeField?: EditingViewField;
  globalFilters: CpsGlobalFilter[];
}
